import classNames from 'classnames';
import * as React from 'react';
const Popup = props => {
  const {
    children,
    prefixCls,
    id,
    overlayInnerStyle: innerStyle,
    bodyClassName,
    className,
    style
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(`${prefixCls}-content`, className),
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(`${prefixCls}-inner`, bodyClassName),
    id: id,
    role: "tooltip",
    style: innerStyle
  }, typeof children === 'function' ? children() : children));
};
export default Popup;